import { Tooltip } from "@material-ui/core";
import * as React from "react";
import "./tooltipInfo.scss";
import { ReactComponent as Icon } from "../../../statics/icons/info.svg";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

interface TooltipInfoProps {
    infoMessage: React.ReactNode;
}

export default function TooltipInfo(props: TooltipInfoProps): React.ReactElement<TooltipInfoProps> {
    const infoMessage = <div dangerouslySetInnerHTML={{ __html: props.infoMessage!.toString() }} />;

    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const toggleTooltip = () => {
        setOpen(!open);
    };

    return (
        <div className="tooltip-info">
            <ClickAwayListener onClickAway={handleClose}>
                <Tooltip title={infoMessage} placement="top-end" arrow open={open}>
                    <Icon onClick={toggleTooltip} className="tooltip-icon" />
                </Tooltip>
            </ClickAwayListener>
        </div>
    );
}
